import {
    createContext,
    FC,
    PropsWithChildren,
    useCallback,
    useContext,
    useState
} from 'react';

export interface SortBy {
    sortingField: string;
    order: SortOrder;
}

type SortOrder = 'Ascending' | 'Descending';

const sortContext = createContext<{
    state: Record<string, SortBy>;
    setSort: (key: string, value: SortBy) => void;
}>({
    state: {},
    setSort: () => null
});

export const SortProvider: FC<PropsWithChildren> = ({ children }) => {
    const [state, setState] = useState<Record<string, SortBy>>(null);

    const setSort = useCallback((key: string, value: SortBy) => {
        setState((current) => ({
            ...current,
            [key]: value
        }));
    }, []);

    return (
        <sortContext.Provider
            value={{
                state,
                setSort
            }}>
            {children}
        </sortContext.Provider>
    );
};

export const useSort = () => useContext(sortContext);
